import { ButtonHTMLAttributes, MouseEvent } from 'react'
import Icon from './Icon'
import { VisibilityToggleWrapper } from './Styles'

interface VisibilityToggleIconProps {
  title?: string
  style?: ButtonHTMLAttributes<HTMLButtonElement>['style']
  toggled?: boolean
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void
}

const VisibilityToggleIcon = ({
  title,
  style,
  toggled,
  onClick,
}: VisibilityToggleIconProps) => (
  <VisibilityToggleWrapper
    title={title}
    style={style}
    toggled={toggled}
    onClick={
      onClick
        ? (e: MouseEvent<HTMLButtonElement>) => {
            e.preventDefault()
            onClick(e)
          }
        : undefined
    }>
    <Icon button name="icon-visible" color="grey" size="large" />
  </VisibilityToggleWrapper>
)

export default VisibilityToggleIcon
